import { TOAST_TYPE } from "~/enum/enum";

interface ToastOptions {
  message: string
  type?: TOAST_TYPE
  duration?: number
  delay?: number
  persistent?: boolean  // 영구 표시 여부
}

const toasts = ref<{
  id: number | null;
  message: string;
  type: string;
  visible: boolean;
  persistent: boolean;
}>({
  id: null,
  message: '',
  type: TOAST_TYPE.NOTICE,
  visible: false,
  persistent: false
})

const toastId = ref(1)  // ✅ 1부터 시작 (0은 falsy라서 v-if에서 false 평가됨)
const hideTimer = ref<ReturnType<typeof setTimeout> | null>(null)

const hide = () => {
  if (toasts.value.visible) {
    toasts.value.visible = false

    // transition 종료 후 값 초기화
    setTimeout(() => {
      toasts.value.id = null
      toasts.value.message = ''
      toasts.value.persistent = false
    }, 300)
  }
}

const show = (options: ToastOptions) => {
  const id = toastId.value++
  const {
    message,
    type = TOAST_TYPE.NOTICE,
    duration = 3000,
    delay = 300,
    persistent = false
  } = options

  // 기존 타이머 클리어 (중복 방지)
  if (hideTimer.value) {
    clearTimeout(hideTimer.value)
    hideTimer.value = null
  }

  // 초기 상태 세팅
  toasts.value.id = id
  toasts.value.message = message
  toasts.value.type = type
  toasts.value.visible = false
  toasts.value.persistent = persistent

  // DOM 업데이트 후 visible=true로 (transition 작동 위해)
  nextTick(() => {
    setTimeout(() => {
      toasts.value.visible = true

      if (!persistent) {
        // 표시 후 duration 만큼 기다렸다가 제거
        hideTimer.value = setTimeout(() => {
          toasts.value.visible = false

          // transition 종료 후 값 초기화
          setTimeout(() => {
            if (toasts.value.id === id) {
              toasts.value.id = null
              toasts.value.message = ''
            }
          }, 300)
        }, duration)
      }
    }, delay)
  })
}

export const useToast = () => {
  return {
    toasts,
    show,
    hide
  }
}

export const Toast = {
  toasts,
  show,
  hide
}
